import { useSearchParams } from "react-router-dom";
import styles from "./Invoice.module.css";

const PdfViewer = () => {
  const [searchParams] = useSearchParams();
  const pdf = searchParams.get("pdf");

  return (
    <div className={styles.pdf_viewer}>
      <iframe
        src={process.env.REACT_APP_S3URL + pdf}
        title="PDF Viewer"
        style={{
          border: "none",
          backgroundColor: "#f4f4f4",
        }}
      />
    </div>
  );
};

export default PdfViewer;
